export default __webpack_public_path__ + "static/media/not-found-image.7e6324c8.png";